<template>
	<div ref="image-container" :style="style" class="wrapper" @click="$emit('click')" :data-aspect-ratio="aspectRatio ? aspectRatio : 'null'">
		<button v-if="supportDeletion" class="content-unit-delete-button btn btn-danger" @click.stop="$emit('delete')">
			<i class="fa fa-minus" aria-hidden="true"></i>
		</button>
	</div>
</template>

<script>
export default {
	props: {
		src: { required: true},
		width: { required: false, type: String},
		height: { required: false, type: String},
		maxWidth: { required: false, type: String},
		maxHeight: { required: false, type: String},
		aspectRatio: { require: false},
		mode: { required: false, type: String, default: 'fill'}, // fit, fill
		supportDeletion: { default: false},
		zoomOnHover: { default: false }
	},
	computed: {
		style() {
			var style ={
				width: this.width ?? 'auto',
				height: this.height ?? 'auto',
				'max-width': this.maxWidth ?? 'auto',
				'max-height': this.maxHeight ?? 'auto'
			}
			style['background-image'] = `url(${this.src})`;
			style['background-repeat'] ='no-repeat';
			style['background-position'] ='center';
			style['background-size'] = `${this.mode == 'fit' ? 'contain' : 'cover'}`;
			return style;
		}
	},
	mounted() {
		if (this.zoomOnHover) {
			const el = this.$refs['image-container'];
			el.addEventListener('mousemove', this.handleMouseMove);
			el.addEventListener('mouseout', this.handleMouseOut);
		}
	},
	beforeDestroy() {
		const el = this.$refs['image-container'];
		el.removeEventListener('mousemove', this.handleMouseMove);
		el.removeEventListener('mouseleave', this.handleMouseOut);
	},
	methods: {
		handleMouseMove(e) {
			const el = this.$refs['image-container'];
			const { left, top, width, height } = el.getBoundingClientRect();
			const x = (e.clientX - left) / width * 100;
			const y = (e.clientY - top) / height * 100;
			el.style.transformOrigin = `${x}% ${y}%`;
			el.style.transform = 'scale(1.5)';
			el.style.transitionDelay = '200ms';
		},
		handleMouseOut() {
			const el = this.$refs['image-container'];
			el.style.transitionDelay = '200ms';
			el.style.transform = 'scale(1)';
		}
	}
}
</script>

<style scoped lang="scss">
	.wrapper {
		transition: transform 0.4s ease;
		touch-action: manipulation;
	}

	.wrapper:hover .content-unit-delete-button {
		display: block;
	}

    .content-unit-delete-button{
        padding: 0;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        line-height: 20px;
        color: white;
        position: absolute;
        border-color: transparent;
        top: 0px;
        right: -10px;
		left: unset;
        display: none;
        z-index: 500;

        i {
            position: relative;
            top: -2px;
        }
    }

</style>